module.exports = __webpack_public_path__ + "static/media/FeedBackSort.0571efa7.svg";